import {forOwn, set, cloneDeep} from "lodash";
import {STANDARD_DATE_TIME_FORMAT} from "Core/const/datetime";
import {getDateString} from "Core/helpers/datetime";
import {
	getBooleanFromTinyInt, getString,
	getTinyIntFormBoolean, isset,
	removeEmptyObjectProps,
	resetObjectValues
} from 'Core/helpers/data';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data.
 * @return {Object}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	forOwn(result, (value, key) => {
		// Remove project filter since it is not actually a filter that user can specify
		if (key === 'projectId') delete result[key];

		// Convert 'isActive' boolean into tiny int
		if (key === 'isActive' && isset(value) && value !== null) set(result, key, getTinyIntFormBoolean(value));

		// Convert campaign ID into string
		if (key === 'campaignId' && isset(value) && value !== null) set(result, key, getString(value));
	});

	return result;
}

/**
 * Get output data from input data
 * @param {Object} input - Input value.
 * @return {Object}
 */
export const output = input => {
	let result = cloneDeep(input);

	forOwn(result, (value, key) => {
		// Convert Date object to appropriate date string
		if (value instanceof Date) set(result, key, getDateString(value, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S));
		
		// Convert 'isActive' tiny int into boolean
		if (key === 'isActive' && isset(value) && value !== null) set(result, key, getBooleanFromTinyInt(value));
	});
	
	// Set proper empty values expected by the API
	result = removeEmptyObjectProps(resetObjectValues(result));

	return result;
}